import { Link } from "react-router-dom";
import { categories, hotTopics, siteMeta } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-100">
      <div className="container-x grid grid-cols-1 gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-mic-2-line"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">独家吃瓜</span>
          </Link>
          <p className="mt-4 text-sm leading-7 text-secondary-200">
            {siteMeta.slogan}。只整理公开信息，不做未证实的推测，把一件事的来龙去脉按顺序讲清楚。
          </p>
          <p className="mt-4 text-sm text-secondary-300">
            <i className="ri-mail-line mr-2"></i>
            {siteMeta.email}
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">站点导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/" className="text-secondary-200 transition-colors hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/archive" className="text-secondary-200 transition-colors hover:text-accent-300">
                事件档案
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-secondary-200 transition-colors hover:text-accent-300">
                关于我们
              </Link>
            </li>
            <li>
              <Link
                to="/about#contact"
                className="text-secondary-200 transition-colors hover:text-accent-300"
              >
                线索投递
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">主题分类</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {categories.slice(1).map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/archive?category=${cat.slug}`}
                  className="text-secondary-200 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">正在复盘</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {hotTopics.slice(0, 5).map((topic) => (
              <li key={topic.slug}>
                <Link
                  to={`/archive/${topic.slug}`}
                  className="block truncate text-secondary-200 transition-colors hover:text-accent-300"
                >
                  {topic.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-secondary-300 sm:flex-row">
          <p>© {new Date().getFullYear()} 独家吃瓜 · 内容为公开信息整理，仅供参考</p>
          <p>{siteMeta.city}</p>
        </div>
      </div>
    </footer>
  );
}